<dx-tabs [scrollingEnabled]="true" [scrollByContent]="true" [showNavButtons]="true"
    [(selectedIndex)]="rfq.indexList" class="list-tab">
    <dxi-tabs-item [text]="L('NEW')" [badge]="badge(0)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('PUBLISHED')" [badge]="badge(1)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('TECHNICAL')" [badge]="badge(2)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('COMMERCIAL')" [badge]="badge(3)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('ANALYSE_WINNER')" [badge]="badge(4)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('FINISHED')" [badge]="badge(5)"></dxi-tabs-item>
    <dxi-tabs-item [text]="L('CANCELLED')" [badge]="badge(6)"></dxi-tabs-item>
</dx-tabs>